module.exports = __webpack_public_path__ + "d98e9a1acd165c744cb78a44cc6ba8dd.png";